import { getCountryUrlPrefix } from "./getCountryUrlPrefix";

export const getBaseUrl: (countryPrefix: string) => string = (countryPrefix) =>
  `${window.location.origin}${getCountryUrlPrefix(countryPrefix)}`;
